function getAbsoluteUrl(store, router, path) {
    return store.state.baseUrl + router.resolve(path).href;
}
export default getAbsoluteUrl;
